export const margins = {
  s: 20,
  m: 30,
  l: 60,
}
